import React from 'react';
import ReactDOM from 'react-dom';

import ModalAvaliacao from '../Atualizacao/ModalAvaliacao';

import './Style.css';

class ListaEmpreendimentos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            avaliacaoLoading: false,
            cityPeriod: props.cityPeriod || null,
            empreendimentos: [],
            errors: {},
            modalAvaliacaoOpen: false,
            selectedBaseToValidate: null,
            motivosAvaliacao: [],
        };
    }

    fetchEvaluations = async () => {
        const {
            cityPeriod,
        } = this.state;

        if (!cityPeriod?.id) {
            return;
        }

        this.setState({
            loading: true,
        });

        try {
            const response = await axios.get(`/executar-auditoria/${cityPeriod.id}`);

            this.setState({
                empreendimentos: response.data?.data || [],
                loading: false
            });

        } catch (error) {
            console.error('Erro ao executar auditoria:', error);

            this.setState({
                loading: false,
            });
        }
    };

    componentDidMount() {
        this.fetchEvaluations();
    }

    getEvaluationGroups = (empreendimento) => {
        const groups = {};

        (empreendimento.evaluations || []).forEach(
            (evaluation) => {
                const evaluationWeight = evaluation.evaluation_weigth;

                if (!evaluationWeight) {
                    return;
                }

                const weightId = evaluationWeight.id;

                if (!groups[weightId]) {
                    groups[weightId] = {
                        evaluationWeight,
                        evaluations: [],
                        conditionals: [],
                    };
                }

                groups[weightId].evaluations.push(
                    evaluation
                );

                if (evaluation.conditional) {
                    groups[weightId].conditionals.push({
                        ...evaluation.conditional,
                        evaluationId: evaluation.id,
                    });
                }
            }
        );

        return Object.values(groups);
    };

    formatConditional = (conditional) => {
        if (!conditional) {
            return '';
        }

        const {
            operator,
            compare_with,
            fixed_value,
            field,
        } = conditional;

        const parts = [];

        if (operator) {
            parts.push(operator);
        }

        if (compare_with) {
            parts.push(compare_with);
        }

        if (fixed_value !== null && fixed_value !== undefined && fixed_value !== '') {
            parts.push(`"${fixed_value}"`);
        }

        if (field) {
            parts.push(`campo: ${field}`);
        }

        return parts.join(' ');
    };

    showModalAvaliacao = (empreendimento) => {
        const evaluationGroups = this.getEvaluationGroups(empreendimento);

        const motivos = evaluationGroups
            .map((group) => {
                const weight = group.evaluationWeight;

                if (!weight) {
                    return null;
                }

                return {
                    id: weight.id,
                    text: `${weight.reason} / ${weight.criterion}`,
                    reason: weight.reason,
                    criterion: weight.criterion,
                    building_type: weight.building_type,
                    building_status: weight.building_status,
                    weigth: weight.weigth,
                };
            }).filter(Boolean);

        this.setState({
            modalAvaliacaoOpen: true,
            selectedBaseToValidate: empreendimento.id,
            motivosAvaliacao: motivos,
        });
    };

    closeModalAvaliacao = () => {
        if (this.state.avaliacaoLoading) {
            return;
        }

        this.setState({
            modalAvaliacaoOpen: false,
            selectedBaseToValidate: null,
            motivosAvaliacao: [],
        });
    };

    handleAvaliacaoSubmit = async (form) => {
        this.setState({
            avaliacaoLoading: true,
        });

        const {
            cityPeriod,
            selectedBaseToValidate,
            empreendimentos,
        } = this.state;

        try {
            const payload = {
                tipo: 'Avaliação',
                base_id: selectedBaseToValidate,
                city_period_id: cityPeriod.id,
                motivos: (form.motivos || []).map((item) => item.id),
                comentario: form.comentario || null,
            };

            await axios.post(
                `/salvar-avaliacao`,
                payload
            );

            this.setState({
                empreendimentos:
                    empreendimentos.filter(
                        (empreendimento) => empreendimento.id !== selectedBaseToValidate
                    ),
                avaliacaoLoading: false,
                modalAvaliacaoOpen: false,
                selectedBaseToValidate: null,
                motivosAvaliacao: [],
            });

            alert('Avaliação adicionada com sucesso');
        } catch (error) {
            console.error('Erro ao salvar avaliação:', error);

            this.setState({
                avaliacaoLoading: false,
            });
        }
    };

    render() {
        const {
            empreendimentos,
            cityPeriod,
            loading,
            modalAvaliacaoOpen,
            avaliacaoLoading,
            motivosAvaliacao,
        } = this.state;

        return (
            <div>
                <div className="lista-empreendimentos-auditados archivo-expanded">
                    <div className="card" style={{ height: '100%' }}>
                        {loading ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i>
                            </div>
                        ) : empreendimentos.length === 0 ? (
                            <p className="title">Nenhum empreendimento inválido.</p>
                        ) : (
                            <div className="table-responsive">
                                <table className="table-stripped">
                                    <thead>
                                        <tr>
                                            <th>Empreendimento</th>
                                            <th>Erro</th>
                                            <th>Avaliar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {empreendimentos.map(
                                            (empreendimento) => {
                                                const evaluationGroups = this.getEvaluationGroups(empreendimento);

                                                return (
                                                    <tr key={empreendimento.id}>
                                                        <td>
                                                            <a
                                                                href={`/building/${empreendimento.building_id}/edit`}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {empreendimento.building_name}
                                                                {' '}
                                                                <i className="fa fa-link"></i>
                                                            </a>
                                                        </td>

                                                        <td>
                                                            <div className="erros-empreendimento">
                                                                {evaluationGroups.map(
                                                                    (group) => (
                                                                        <div key={group.evaluationWeight.id}>
                                                                            {group.evaluationWeight.reason} / {group.evaluationWeight.criterion}
                                                                        </div>
                                                                    )
                                                                )}
                                                            </div>
                                                        </td>

                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-editar"
                                                                title="Adicionar avaliação"
                                                                onClick={() =>
                                                                    this.showModalAvaliacao(
                                                                        empreendimento
                                                                    )
                                                                }
                                                            >
                                                                <i className="fa fa-plus"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        <a
                            href={`/atualizacao-nova/${cityPeriod.id}`}
                            role="button"
                            className='btn btn-voltar'
                        >Voltar</a>
                    </div>
                </div>

                <ModalAvaliacao
                    open={modalAvaliacaoOpen}
                    onClose={this.closeModalAvaliacao}
                    onSubmit={this.handleAvaliacaoSubmit}
                    loading={avaliacaoLoading}
                    baseId={this.state.selectedBaseToValidate}
                    cityPeriod={cityPeriod}
                    initialMotivos={motivosAvaliacao}
                />
            </div>
        );
    }
}

const element = document.getElementById('app-lista-empreendimentos-auditados');

if (element) {
    const props = {
        cityPeriod: JSON.parse(element.dataset.cityPeriod || '{}'),
    };

    ReactDOM.render(<ListaEmpreendimentos {...props} />, element);
}
export default ListaEmpreendimentos;